import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const SettingsContext = createContext(null);

export const SettingsProvider = ({ children }) => {
  const { user } = useAuth();
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadError, setLoadError] = useState(false);

  /** Apply settings from a successful fetch (e.g. Settings page) and clear global error. */
  const ingestSettings = useCallback((data) => {
    setSettings(data);
    setLoadError(false);
  }, []);

  const refresh = useCallback(async () => {
    if (!user) {
      setSettings(null);
      setLoadError(false);
      return;
    }
    setLoading(true);
    setLoadError(false);
    try {
      const res = await api.get("/settings");
      setSettings(res.data);
      setLoadError(false);
    } catch (err) {
      setSettings(null);
      setLoadError(true);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return (
    <SettingsContext.Provider value={{ settings, setSettings, loading, loadError, refresh, ingestSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
